// extracted by mini-css-extract-plugin
export default {"resizedImage":"a0uwAr"};